import "./index.less";
import closeImg from "@/assets/images/cha.png";
import { useNavigate } from "react-router-dom";
import actions from "@/stores/globalstate";

const prefix = 'license-notify-info-wrap';
const NotifyInfo = (props: any) => {
    const { data, onCancel } = props;

    const navigate = useNavigate();

    //跳转license
    const goLicense = () => {
        // navigate(`/#/khlinks/kh_system/License`);
        const url = "/kh_system/License"
        actions.setGlobalState({ hashPath: url });
        onCancel();
    }

    return (
        <div className={prefix}>
            <div className={`${prefix}-title`}>
                <div className={`${prefix}-text`}>License到期提醒</div>
                <div className={`${prefix}-img`} onClick={() => { onCancel() }}><img src={closeImg} alt="" /></div>
            </div>
            <div className={`${prefix}-content`}>{data || ''}</div>
            <div className={`${prefix}-bottom`} onClick={goLicense}>
                查看
            </div>
        </div>
    )
}

export default NotifyInfo